import React, { useState, useEffect } from "react";
import { makeStyles } from '@material-ui/core/styles';
import { SketchPicker } from 'react-color'

import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import SvgIcon from '@material-ui/core/SvgIcon';
import Tooltip from '@material-ui/core/Tooltip';
import Popover from '@material-ui/core/Popover';

const useStyles = makeStyles(theme => ({
    active: {
        backgroundColor: 'rgba(0, 0, 0, 0.10);',
        "&:hover" : {
            backgroundColor: 'background-color: rgba(0, 0, 0, 0.10);',
        }
    },
}));

const key = 'FBG_COLOR_';

export default function Color(props) {

    const classes = useStyles();

    const { editorState, onToggle, editorFocus } = props;

    const styleNames = editorState.getCurrentInlineStyle();

    const [ colorPickerAnchorEl, setColorPickerAnchorEl ] = useState(null);
    const [ fontColor, setFontColor ] = useState('transparent');

    useEffect(() => {
        const color = styleNames.find(style => style.startsWith(key))?.split(key)[1];

        setFontColor(color || 'transparent');
    }, [styleNames])

    const handleColor = (color, event) => {
        event.preventDefault();

        if (color && color.hex) {
            onToggle(color.hex, key);
            setFontColor(color);
        }
        //setTimeout(() => editorFocus(), 0);
    }

    // Color Picker Popover....................

    const openColorPicker = (event) => {
        event.preventDefault();
        setColorPickerAnchorEl(event.currentTarget);
    }

    const closeColorPicker= () => {
        setColorPickerAnchorEl(null);
        onToggle(fontColor, key);
        editorFocus();
        //
    }

    return (
        <>
            <ButtonGroup>
                <Tooltip title="Font Background Color">
                    <Button aria-label="Font Color" size="small" onMouseDown={event => openColorPicker(event)}>
                        <SvgIcon>
                            <path d="M16.56 8.94L7.62 0 6.21 1.41l2.38 2.38-5.15 5.15c-.59.59-.59 1.54 0 2.12l5.5 5.5c.29.29.68.44 1.06.44s.77-.15 1.06-.44l5.5-5.5c.59-.58.59-1.53 0-2.12zM5.21 10L10 5.21 14.79 10H5.21zM19 11.5s-2 2.17-2 3.5c0 1.1.9 2 2 2s2-.9 2-2c0-1.33-2-3.5-2-3.5z"/>
                            <path style={{ color: fontColor }} d="M0 20h24v4H0z"/>
                        </SvgIcon>
                    </Button>
                </Tooltip>
            </ButtonGroup>
            <Popover
                open={Boolean(colorPickerAnchorEl)}
                anchorEl={colorPickerAnchorEl}
                onClose={closeColorPicker}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                disableAutoFocus
                disableEnforceFocus
                disableRestoreFocus
                >
                <SketchPicker color={fontColor} onChange={handleColor} />
            </Popover>
        </>

    );
}
